import * as list from './list';
import * as info from './info';

export default {
  ...list,
  ...info,
};
